import React, { useState, useEffect } from "react";
import axios from "axios";

const Form3 = (props) => {
  const [toEmail, setToEmail] = useState('');		 
  useEffect(() => {				
	setToEmail(`${process.env.REACT_APP_EMAIL_ADDRESS}`);		 
  },[]); 
  
  const [formData, setFormData] = useState({
    username: "",
    email: "",
	phone: "",
	subject: "",
    message: "",
	toemail: toEmail,
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorSubmitted, setErrorSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle form data changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission  
  const handleSubmit = async (event) => {
	  event.preventDefault();	  
	  try {
		 await axios({
              method: "post",
              url: `${process.env.PUBLIC_URL}/getApi.php`,
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
              }).then(function (response) {               
			    setFormData({
					username: "",
					email: "",
					phone: "",
					subject: "",
					message: "",
					toemail: toEmail,					
				  });
			    setSuccessMessage(response.data.message);
				setFormSubmitted(true);               
            }).catch(function (error) {
				setErrorSubmitted(true);                              
				setErrorMessage('error is '+ error.msg);
            });		
		
	  } catch (error) {
		console.error("ERROR:-"+error);		
	  }
	};
	
	function ErrorMessage(props) {
	  return (
		<div className="error-message alert alert-warning">
		  <p>{props.message}</p>
		</div>
	  );
	}
	
	function SuccessMessage(props) {
		  return (
			<div className="success-message alert alert-success">
			  <p>{props.message}</p>
			</div>
		  );
		}

	 useEffect(() => {
		// when the component is mounted, the alert is displayed for 3 seconds
		setTimeout(() => {
		  setFormSubmitted(false);
		  setErrorSubmitted(false); 
		}, 20000);
	  });  
	  function Reset()
	  {
	  			setFormData({
					username: "",
					email: "",
					message: "",
					toemail: toEmail,					
				 });
		}
		
  return (
   		<>
		{formSubmitted && <SuccessMessage message={successMessage} />}
		{errorSubmitted && <ErrorMessage message={errorMessage} />}
			
		<form  className="cons-contact-form p-a30 bg-gray" method="post" onSubmit={handleSubmit}>
			
			<div className="row">
					
				<div className="col-md-12">
					<div className="form-group">
						<div className="input-group">
							<span className="input-group-addon"><i className="fa fa-user"></i></span>
							
							<input
							  type="text"
							  required
							  className="form-control" 
							  name="username"
							  placeholder="Name"
							  value={formData.username}
							  onChange={handleInputChange}
							/>
						</div>
					</div>
				</div>

				<div className="col-md-12">
					<div className="form-group">
						<div className="input-group">
							<span className="input-group-addon"><i className="fa fa-envelope"></i></span>
							<input
							  type="email"
							  required
							  className="form-control" 
							  name="email"
							  placeholder="Email"
							  value={formData.email}
							  onChange={handleInputChange}
							/>
						</div>
					</div>

				</div>
				<input name="phone" type="hidden" className="form-control" value={'0000000000'} required placeholder="Phone" />
				<input name="subject" type="hidden" className="form-control" value={'Contact Us Form'} required placeholder="Subject" />
				
				
				<div className="col-md-12">
					<div className="form-group">
						<div className="input-group">
							<span className="input-group-addon v-align-m"><i className="fa fa-pencil"></i></span>
							
							 <textarea
								  name="message"
								  className="form-control" 
								  placeholder="Message"
								  rows="4"
								  value={formData.message}
								  onChange={handleInputChange}
								/>
						</div>
					</div>
				</div>

				<div className="col-md-12 text-right">
					<input type="hidden" id="toemail" name="toemail" value={toEmail} />
					<button name="submit" type="submit" value="Submit" className="site-button  m-r15">Submit  <i className="fa fa-angle-double-right"></i></button>
					<button name="Resat" type="reset" value="Reset"  className="site-button "  onClick={Reset} >Reset  <i className="fa fa-angle-double-right"></i></button>
				</div>

			</div>
			
	   </form>
   </>	  
  );
};
export default Form3;